const SET_INFO = (state, payload) => {
    state.info = '';
    state.info = payload;
}

const CLEAR_INFO = (state) => {
    state.info = '';
}

const CLEAR_STATES = (state) => {
    state.info = '';
}

export {
    SET_INFO,
    CLEAR_INFO,
    CLEAR_STATES
}
